<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="pt01">
<div class="partHead" id="ph01">
<p class="paraCenter" style="text-indent:0%;"><img alt="image" height="575" src="Images/pt01.jpg" width="381"/></p></div>
<div class="partBody">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780765316578_pt01.vue?357372ea